<app-page-header title="Nuevo expediente" subtitle="" [accent]="true"></app-page-header>

<div class="container">

    <div class="cont-check" #contCheck>
        <app-event-register-check-balls [page]=page></app-event-register-check-balls>
    </div>

    <div class="step-header">
        <h2 *ngIf="page === 0">Declaración</h2>
        <h2 *ngIf="page === 1">Datos del asegurado</h2>
        <h2 *ngIf="page === 2">Datos de contacto para gestionar este parte</h2>
        <p *ngIf="page === 0">Selecciona tu seguro y detalla lo ocurrido</p>
    </div>

    <div class="step-card">

        <div class="tabs">
            <div class="content">
                <section *ngIf="(page === 0)">
                    <app-event-register-first-step (selected)="onSelectCallback($event)" [policy]="data"
                        [formGroup]="firstStepForm">
                    </app-event-register-first-step>
                </section>
                <section *ngIf="(page === 1)">
                    <app-event-register-second-step [formGroup]="secondStepForm" (onInsuredSelected)="onInsuredSelected($event)" [insuredList]="insuredList" [policy]="data" [prefixData]="prefixData">
                    </app-event-register-second-step>
                </section>
                <section *ngIf="(page === 2)">
                    <app-event-register-third-step [formGroup]="thirdStepForm" [policy]="data" [prefixData]="prefixData">
                    </app-event-register-third-step>
                </section>
            </div>
        </div>

        <div class="buttons">

            <div class="message" *ngIf="undefined !== messages">{{messages}}</div>

            <div class="buttons-inner">
                <app-spinner-button label="Paso anterior" *ngIf="(page !== 0)" [enabled]="((page !== 0) && (!running))"
                    [running]="false" customSpinnerButton="btn-step-secondary" (click)="onPreviousPage()">
                </app-spinner-button>
                <app-spinner-button [label]="getButtonLabel()" *ngIf="(undefined !== data)" [enabled]="!disableNextPage()"
                    [running]="running" customSpinnerButton="btn-step-primary" (click)="onNextPage()">
                </app-spinner-button>
            </div>

        </div>

    </div>

</div>

<!-- Eliminado a petición de Carmen
<app-articles></app-articles>
-->

<app-footer></app-footer>